import { useMemo, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useRefinementList } from "react-instantsearch-core";
import { filterRecentlyModified } from "@actions/catalog-actions";

export function useRecentlyModifiedFilters() {
  return useSelector((state) => state.catalog.filtersRecentlyModified);
}

export function useFilterRecentlyModified() {
  const dispatch = useDispatch();

  return (filter) => dispatch(filterRecentlyModified(filter));
}

export function useSizes() {
  const { items: inStockItems } = useRefinementList({
    attribute: "in_stock",
  });
  const { items: allSizesItems, refine: refineAllSizes } = useRefinementList({
    attribute: "sizes",
  });
  const { items: availableSizesItems, refine: refineAvailableSizes } = useRefinementList({
    attribute: "available_sizes",
  });

  const { sizeItems, isFilterAvailableChecked } = useMemo(() => {
    const isNotInStockApplied = inStockItems.find((item) => item.label === "false")?.isRefined;
    const isFilterAvailableCheckedRes = !isNotInStockApplied;

    let sizeItemsRes;

    if (isFilterAvailableCheckedRes) {
      sizeItemsRes = availableSizesItems;
    } else {
      sizeItemsRes = allSizesItems;
    }

    return {
      sizeItems: sizeItemsRes,
      isFilterAvailableChecked: isFilterAvailableCheckedRes,
    };
  }, [inStockItems, availableSizesItems, allSizesItems]);

  const refineSize = useCallback(
    (optionValue) => {
      if (isFilterAvailableChecked) {
        return refineAvailableSizes(optionValue);
      }

      return refineAllSizes(optionValue);
    },
    [isFilterAvailableChecked, refineAllSizes, refineAvailableSizes],
  );

  return { sizeItems, refineSize, isFilterAvailableChecked };
}
